import type Notification from '@global-interfaces/Notification';

import api from './config';

export interface NotificationPage<T> {
  count: number;
  next: number | null;
  previous: number | null;
  next_url: string | null;
  previous_url: string | null;
  results: T[];
}

export interface NotificationUnreadCount {
  unread: number;
}

export interface MarkAllNotificationsReadResponse {
  updated: number;
  read_at: string;
}

export interface NotificationListParams {
  page?: number;
  page_size?: number;
  is_read?: boolean;
  event_type?: string;
  created_at_after?: string;
  created_at_before?: string;
}

const notificationsAPI = {
  list: async (params: NotificationListParams = {}) =>
    api.get<NotificationPage<Notification>>('/notifications/', { params }).then(({ data }) => data),
  unreadCount: async () => api.get<NotificationUnreadCount>('/notifications/unread-count/').then(({ data }) => data),
  markRead: async (id: number) =>
    api.patch<Notification>(`/notifications/${id}/mark-read/`, {}).then(({ data }) => data),
  markAllRead: async () =>
    api.patch<MarkAllNotificationsReadResponse>('/notifications/mark-all-read/', {}).then(({ data }) => data)
};

export default notificationsAPI;
